// extracted by mini-css-extract-plugin
module.exports =  {"tips":"tips__p1XVj"};